// Fixed backend connection details used by the dashboards that call the
// o2c-backend KPI/campaign APIs (Campaigns, Onboarding).
//
// This ships inside the public static bundle, same as EMS's existing
// hardcoded credential (public/ems/index.html) — anyone who opens the
// deployed site's JS can read it. That's an accepted tradeoff already made
// for EMS; this just applies the same one here instead of asking each
// browser to enter a per-device access key.
//
// BACKEND_BASE_URL is baked in at build time via REACT_APP_BACKEND_BASE_URL
// (see .github/workflows/deploy.yml), falling back to localhost for `npm start`.
export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL || "https://api.nakad.co/qsync";
export const BACKEND_DIRECT_ACCESS_CODE = "3ba22542974235f7604f";
